module.exports = __webpack_public_path__ + "files/f23b06359848dc8a9995f3a53c961512.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-1.png
// module id = 1616
// module chunks = 60